import parser from "html-react-parser"
// import domToReact from "html-react-parser/lib/dom-to-react"
import React from "react"

import { Gallery } from "./components/Gallery/Gallery"
import { Video } from "./components/Video/Video"

export const parseContent = (content: string): JSX.Element | JSX.Element[] => {
  // FIXME: Отладка картинок
  const host = `` //`http://sistema.ru.bitrix.dev.dabb.pro/`

  return parser(content, {
    replace: ({ attribs, children }) => {
      // Обработка сниппета Галереи
      if (attribs?.class === "wysiwyg-gallery__wrapper") {
        const slides: Array<{ source: string; title: string }> = []
        let caption = ""

        children?.forEach((n1) => {
          if (n1.attribs?.class === "wysiwyg-gallery__list") {
            n1.children?.forEach((n2) => {
              if (n2.name === "img") {
                slides.push({
                  source: `${host}${n2.attribs?.src}`,
                  title: `${n2.attribs?.title}`,
                })
              }
            })
          }
          if (n1.attribs?.class === "wysiwyg-gallery__caption") {
            n1.children?.forEach((n2) => {
              if (n2.type === "text") {
                caption = `${n2.data}`.trim()
              }
            })
          }
        })

        return <Gallery slides={slides} title={caption} />
      }

      // Обработка сниппета Видео
      if (attribs?.class === "wysiwyg-video__wrapper") {
        let source = ""
        let caption = ""

        children?.forEach((n1) => {
          if (n1.attribs?.class === "wysiwyg-video__source") {
            n1.children?.forEach((n2) => {
              if (n2.attribs?.href) {
                source = n2.attribs?.href
              }
            })
          }
          if (n1.attribs?.class === "wysiwyg-video__caption") {
            n1.children?.forEach((n2) => {
              if (n2.type === "text") {
                caption = `${n2.data}`.trim()
              }
            })
          }
        })

        return <Video src={source} title={caption} />
      }
    },
  })
}
